class VideoPlayer {
  init() {
    const videoBanner = document.querySelector(".banner__youtube");
    if (videoBanner) {
      const playbtn = document.querySelector('.js-videoplaybtn');
      let player = null;

      function pausePlayer() {
        const plyr = videoBanner.querySelector('.plyr');
        player.stop();
        videoBanner.classList.remove('banner__youtube--playing');
        plyr.classList.remove('plyr__show');
        playbtn.classList.remove('hide');
        plyr.removeEventListener('pause', pausePlayer, false);
      }
      function videoEnd() {
        const plyr = videoBanner.querySelector('.plyr');
        player.stop();
        videoBanner.classList.remove('banner__youtube--playing');
        plyr.classList.remove('plyr__show');
        playbtn.classList.remove('hide');
        plyr.removeEventListener('ended', videoEnd, false);
      }

      playbtn.addEventListener('click', e => System.import(/* webpackChunkName: "videoplayer" */ '../utilities/plyr').then((p) => {
        const Plyr = p.default;

        player = new Plyr('#player', {
          fullscreen: false
        });

        const plyr = videoBanner.querySelector('.plyr');
        player.play();
        plyr.addEventListener('pause', pausePlayer, false);
        plyr.addEventListener('ended', videoEnd, false);
        videoBanner.classList.add('banner__youtube--playing');
        plyr.classList.add('plyr__show');
        playbtn.classList.add('hide');
      }));
      //player.poster = posterSrc
    }

    const videoBannerMp4 = document.querySelector(".banner__mp4");
    if (videoBannerMp4 != null) {
      if (window.innerWidth > 640) {
        videoBannerMp4.play();
      }
    }
  }
}

export default new VideoPlayer();
